import { fetchGet } from '../helperApi'

export const fetchHistoryInspectionsApi = params => {
    return fetchGet(`inspections`, params)
}
